import Navbar from "./navbar";

export default function Header(){
    return (
<>

<header className="absolute w-full z-10">
    <Navbar/>
</header>

</>


    )
}